// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"InfoTooltip_tooltipIcon__Q0vDc"};